import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  info: {
    backgroundColor: theme.palette.red_50.main,
    padding: 8,
    borderRadius: 8,
    marginBottom: 16,
    color: theme.palette.red_100.main
  },
}))
